var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12", align: "center" } },
    [
      _c(
        "v-row",
        { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
        [
          _vm._l(_vm.videoStreamList, function (item, index) {
            return _c(
              "v-col",
              {
                key: item.id,
                staticClass: "ma-0 pa-2",
                class: {
                  non_display:
                    _vm.videoStreamList[index] == undefined ||
                    _vm.streamingUrlLoading,
                },
                attrs: { cols: "4", align: "center" },
              },
              [
                _c("ThumbnailListItem", {
                  attrs: {
                    item: item,
                    index: index,
                    imgLoaders: _vm.imgLoaders,
                    streamingUrlLoading: _vm.streamingUrlLoading,
                  },
                  on: { onLoad: _vm.onLoadFunc },
                }),
              ],
              1
            )
          }),
          _vm.videoStreamList.length == 0 && _vm.streamingUrlLoading == false
            ? _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-15",
                  attrs: { cols: "12", align: "center" },
                },
                [_vm._v(" " + _vm._s(_vm.t("noData")) + " ")]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm.streamingUrlLoading
        ? [
            _c("ImageSkeleton", {
              attrs: { loaderCount: 9, width: "100%", height: "208px" },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }